import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default = _resolveComponent("default")!
  const _component_error_404 = _resolveComponent("error-404")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createVNode(_component_default)
    ]),
    failure: _withCtx(() => [
      _createVNode(_component_error_404)
    ]),
    _: 1
  }))
}